import Button from '@/components/Button';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import PromotionTable from '@/modules/product/components/PromotionTable';
import { PromotionAddPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { PercentBadgeIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';

const PromotionList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <>
      <SettingsHeader title="Promotions" icon={<PercentBadgeIcon className="w-6 h-6" />}>
        <Button
          to={PromotionAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Add Promotion
        </Button>
      </SettingsHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <PromotionTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </>
  );
};

export default PromotionList;
